import React, { Fragment, useState, useEffect } from "react";
import { useSelector } from 'react-redux'
import { useHistory } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import classNames from "classnames";
import ReactGA    from 'react-ga';
import Cookies from 'js-cookie';

import Header  from "~/layout/header";
import Footer  from "~/layout/footer";
import Sidebar from "~/layout/sidebar";

import AdBlockerModal           from "~/components/adBlock/WarningModal";
import OverlayModal             from "~/components/overlayModal";
import PushNotificationQuestion from "~/components/pushNotificationQuestion";

import * as serviceWorkerRegistration from '~/serviceWorkerRegistration';
import 'react-toastify/dist/ReactToastify.css';

import security  from "~/services/security";
import useResize from "~/hooks/useResize";

const App = ({ children, background, expandedHeader, setExpandedHeader, breakpoint })=> {

  const [ width ]                     = useResize();
  const [overlayOpen, setOverlayOpen] = useState(false);

  const configDB    = useSelector((content)=> content.Customizer);
  const history     = useHistory();

  const currentUser      = security.currentUserValue;
  const config_primary   = configDB.color.primary_color;
  const config_secondary = configDB.color.secondary_color;

  ReactGA.initialize(process.env.REACT_APP_GA_KEY);

  const isIOS = [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(window.navigator?.userAgentData?.platform || window.navigator?.platform || 'unknown')
      || (window.navigator.userAgent.includes("Mac") && "ontouchend" in document);

  useEffect(()=> {
    window.addEventListener("popstate", _e => document.body.style.overflowY = "scroll");
  }, []);

  useEffect(()=> {
    if(isIOS) return;
    if (!currentUser || Notification.permission !== 'default' || Cookies.get("PushNotificaionQuestion") ) return;
    setTimeout(()=> {
      setExpandedHeader(false);
      setOverlayOpen(true);
    }, 750);
    return ()=> new AbortController().abort();

  }, [currentUser]);

  useEffect(()=> {
    return history.listen((location)=> {
      ReactGA.set({ page: location.pathname });
      ReactGA.pageview(location.pathname);
    });
  }, [history]);


  serviceWorkerRegistration.register({
    onSuccess: (reg)=> console.log('you are in offline mode', reg),
    onUpdate: (reg)=> console.log('should update:', reg),
  });

  useEffect(() => {
    document.documentElement.style.setProperty('--theme-deafult', config_primary);
    document.documentElement.style.setProperty('--theme-secondary', config_secondary);
  }, []);

  console.warn = () => {};

  return (
    <Fragment>
      <div className={ classNames("page-wrapper", currentUser ? (width <= breakpoint ? "compact-wrapper" : "horizontal-wrapper material-type") : '')}>
        {currentUser ? <Header expanded={expandedHeader} setExpanded={setExpandedHeader} /> : null}
        <div className="page-body-wrapper" style={{ paddingTop: expandedHeader && currentUser ? 130 : 0, background }}>
          {currentUser ? <Sidebar breakpoint={breakpoint} /> : null}
          <div className="page-body" style={{ marginBottom:  currentUser && width < breakpoint ? 75 : 0, marginTop: currentUser && width < breakpoint ? 60 : 0, paddingTop: currentUser ? (expandedHeader ? 0 : 20) : 0 }}>
            {children}

            {!isIOS && <OverlayModal opened={overlayOpen}>
              <PushNotificationQuestion setOverlayOpen={setOverlayOpen} setExpandedHeader={setExpandedHeader} breakpoint={breakpoint} />
            </OverlayModal> }
          </div>
          {currentUser ? <Footer /> : null}
        </div>
      </div>
      <ToastContainer />
      <AdBlockerModal />
    </Fragment>
  );
};

export default App;
